module.exports = "<i class=\"kng-icon small kng-icon-info kng-bubble-tip-icon\" placement=\"{{placement}}\" kngBubbleTip=\"{{message}}\"></i>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-bubble-tip/kng-bubble-tip-icon.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-bubble-tip/kng-bubble-tip-icon.component.html
// module chunks = main